import { apiClient as ApiClient } from "../../../../services/apiClient.js"

export const apiClient = {
  async getNextNumber(step, result, settings) {
    try {
      const response = await ApiClient.request(`/next-number`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          step,
          result,
          settings,
        }),
      })

      return response.number
    } catch (error) {
      console.error("Failed to get next number:", error)
      throw error;
    }
  },
}
